__turbopack_context__.v({
  "container": "OutletBusinessInformation-module-scss-module__RhZwZW__container",
});
